import { ReactNode } from "react";

type Tracker = (updatedNode: ReactNode) => void;

let portals: Record<string, ReactNode> = {};

const trackers: Record<string, Tracker[] | undefined> = {};

const runTrackers = (name: string) =>
  trackers[name]?.forEach((tracker) => tracker(portals[name]));

export const getPortal = (name: string) => portals[name];

export const update = (name: string, node?: ReactNode) => {
  portals[name] = node;
  runTrackers(name);

  const clear = () => {
    portals[name] = undefined;
    runTrackers(name);
  };

  return clear;
};

export const track = (name: string, callback: Tracker) => {
  trackers[name] = trackers[name] ? trackers[name] : [];
  trackers[name]?.push(callback);
  callback(portals[name]);

  const untrack = () => {
    trackers[name]?.find((tracker, index) => {
      if (tracker !== callback) {
        return false;
      }

      trackers[name]?.splice(index, 1);
      return true;
    });
  };

  return untrack;
};
